import React from 'react';
import { Player } from 'video-react';
import classNames from 'classnames/bind';

import styles from './LargeFlightCard.module.css';


import jetSuite from './video/jetsuitex-480p.mov';
import jetSuitePoster from './video/jetsuitex.jpg';

import airCanada from './video/air-canada-480p.mov';
import airCanadaPoster from './video/air-canada.jpg';

import fiji from './video/fiji-airways-480p.mov';
import fijiPoster from './video/fiji-airways.jpg';

import surfair from './video/surfair-480p.mov';
import surfairPoster from './video/surfair.jpg';

import united from './video/united-card-480p.mov';
import unitedPoster from './video/united-card.jpg';

import virgin from './video/virgin-australia-480p.mov';
import virginPoster from './video/virgin-australia.jpg';

const cx = classNames.bind(styles);

const videos = { jetSuite, airCanada, fiji, surfair, united, virgin }
const posters = { jetSuitePoster, airCanadaPoster, fijiPoster, surfairPoster, unitedPoster, virginPoster }

const LargeFlightCard = ({ video, image, text }) => {

  const textStyle = cx({
    text: true,
    smallWidth: text.indexOf('Pilatus') > -1 
    || text.indexOf('Embr') > -1 
    || text.indexOf('Snacks &') > -1
    || text.indexOf('Airbnb Lounge') > -1 
    || text.indexOf('Breakfeast & Wifi') > -1 
  })

  const gradientStyle = cx({
    flightCardLargeGradient: true,
    united: video === 'united',
    surfair: video === 'surfair',
    virgin: video === 'virgin',
    jetsuite: video === 'jetSuite',
    airCanada: video === 'airCanada',
    fiji: video === 'fiji',
  })

  const getContent = (video, image) => {
    if (video) {
      return (
        <div>
          <Player
            playsInline
            preload={'auto'}
            fluid={false}
            autoPlay
            loop
            height={470}
            width={335}
            muted
            poster={posters[`${video}Poster`]}
            src={videos[video]}
          />
          <div className={gradientStyle}/>
        </div>
      )
    } else if(image) {
      return <img src={image ? require(`./images/${image}`) : null} width='335' height="439" alt="" />
    }

    return null;

  }
  return(
    <div className={styles.largeCardWrapper} >
      <h2 className={textStyle}>{text}</h2>
      <div className={styles.flightCardLarge}>
        { getContent(video, image)}
      </div>
    </div>
  )
}

export default LargeFlightCard;



// WEBPACK FOOTER //
// ./src/components/LargeFlightCard/LargeFlightCard.jsx